import Markdown from 'react-markdown';

export type Density = 'comfortable' | 'compact';

function getMessageParagraphClass(density: Density): string {
  return density === 'comfortable' ? 'mb-3 last:mb-0' : 'mb-2 last:mb-0';
}

function buildChatMarkdownComponents(density: Density) {
  const paragraphClass = getMessageParagraphClass(density);
  return {
    p: ({ children }: { children?: React.ReactNode }) => <p className={paragraphClass}>{children}</p>,
    table: ({ children }: { children?: React.ReactNode }) => (
      <div className="overflow-x-auto">
        <table>{children}</table>
      </div>
    ),
    a: ({ href, children }: { href?: string; children?: React.ReactNode }) => (
      <a
        href={href}
        className="font-medium underline underline-offset-2"
        target="_blank"
        rel="noreferrer noopener"
      >
        {children}
      </a>
    ),
    img: () => null,
  };
}

export function ProvenanceAssistantMessage({ text, density }: { text: string; density: Density }) {
  return (
    <Markdown
      className="prose prose-sm max-w-none break-words text-foreground [&>*:first-child]:mt-0 [&>*:last-child]:mb-0 [&_a]:text-primary"
      components={buildChatMarkdownComponents(density)}
    >
      {text}
    </Markdown>
  );
}

export function MemberMessageMarkdown({ text, density }: { text: string; density: Density }) {
  return (
    <Markdown
      className="prose prose-sm max-w-none break-words prose-invert text-primary-foreground [&>*:first-child]:mt-0 [&>*:last-child]:mb-0 [&_a]:text-primary-foreground/90"
      components={buildChatMarkdownComponents(density)}
    >
      {text}
    </Markdown>
  );
}
